// Body for the get-rate (billing confirmation) call. Items carry only ids and
// quantities — the backend resolves listings/seller from the ids; full cart
// objects are client-side state and must not go over the wire.
export const buildRateQuotePayload = ({ form, storeItems, finalSellerId }) => ({
  seller_id: parseInt(finalSellerId, 10),
  full_name: form.full_name,
  phone: form.phone,
  email: form.email,
  billing_address_line1: form.billing_address_line1,
  billing_address_line2: form.billing_address_line2,
  city: form.city,
  state: form.state,
  postal_code: form.postal_code,
  country: form.country,
  currency: form.currency,
  items: storeItems.map((item) => ({
    card_listing_id: item.card_listing.id,
    quantity: item.quantity,
  })),
});
